import { render, staticRenderFns } from "./PaginationData.vue?vue&type=template&id=d0f69c60&scoped=true"
import script from "./PaginationData.vue?vue&type=script&lang=js"
export * from "./PaginationData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0f69c60",
  null
  
)

export default component.exports